/**
 * Inline SVG icon helpers — premium replacements for the unicode glyphs
 * (→ ← ✓ ×) we used to put in button labels.
 *
 * Each function returns a self-contained `<svg>` string sized for the
 * surface it's used on. Stroke colour comes from `currentColor` so the
 * icon picks up the parent button's text colour (white-on-purple,
 * muted-on-ghost, etc) without per-call style overrides.
 *
 * Usage:
 *   <button>Continue ${arrowRight()}</button>
 *   <button>${arrowLeft()} Back</button>
 *   <span>${check()} Connected</span>
 *   <button>${close()}</button>
 *
 * Sizing:
 *   - 12px default — sits inline with body text in buttons.
 *   - opts.size overrides for headers / hero CTAs.
 */
function _svg(path, size = 12, strokeWidth = 2.4) {
    return `<svg class="i-svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`;
}

export function arrowRight(opts = {}) {
    return _svg('<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>', opts.size, opts.strokeWidth);
}

export function arrowLeft(opts = {}) {
    return _svg('<line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>', opts.size, opts.strokeWidth);
}

export function check(opts = {}) {
    return _svg('<polyline points="20 6 9 17 4 12"/>', opts.size, opts.strokeWidth);
}

export function close(opts = {}) {
    return _svg('<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>', opts.size || 14, opts.strokeWidth || 2.25);
}

export function copy(opts = {}) {
    return _svg('<rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>', opts.size, opts.strokeWidth);
}
